export default "__VITE_ASSET__yyXqff7i__"